import i18next from "i18next";

// Colunas do grid.
export const Columns = [
	{
		headerName: 'name',
		field: 'name',
		filter: true,
		width: 350
	},
	{
		headerName: 'category',
		field: 'category.name',
		filter: true
	},
	{
		headerName: 'price',
		field: 'price',
		type: 'currency'
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans'
	}
]

/**
 * Tempo de execução na listagem de serviços.
 *
 * Zero é um valor legítimo (o serviço não reserva janela na agenda), mas quase sempre é
 * cadastro por terminar: o campo nasce zerado. A marca de atenção distingue os dois casos
 * do "40 min" das demais linhas sem esconder o valor real.
 */
const durationRenderer = (params) => {
	const duration = Number(params.value);

	if (duration > 0) {
		return `${duration} min`;
	}

	return (
		<span
			className="service-duration-missing"
			title={i18next.t('service_duration_missing_warning')}
		>
			<i className="fas fa-triangle-exclamation"></i>
			{i18next.t('service_duration_default_short')}
		</span>
	);
};

/**
 * A listagem de serviços mostra o tempo de execução; a de produtos não, porque produto
 * não ocupa janela na agenda e o campo é sempre nulo.
 */
export const ServiceColumns = [
	{
		headerName: 'name',
		field: 'name',
		filter: true,
		width: 320
	},
	{
		headerName: 'category',
		field: 'category.name',
		filter: true
	},
	{
		// "Tempo" basta na listagem: o valor já vem com a unidade ("40 min"), e o cabeçalho
		// completo obrigava uma coluna larga para uma informação curta.
		headerName: 'service_duration_short',
		field: 'duration',
		width: 110,
		cellRenderer: durationRenderer
	},
	{
		headerName: 'price',
		field: 'price',
		type: 'currency'
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans'
	}
]
